export const strings = {
  defaultTitle: 'Something went wrong',
  defaultError:
    'Check your internet connectivity and try refreshing the page. If the problem persists, log an issue with support.',
  retryMessage:
    'Check your internet connectivity and try again. If the problem persists, log an issue with support.',
  errorHeadline: 'Something went wrong',
  noResultsHeadline: 'No Results Found',
  noResultsMessage: 'No customers found. Try adjusting your search.',
  tryAnotherSearch: 'Try another search',
  tryDifferentFilters: 'Try a different set of filters',
  labels: {
    retry: 'Retry',
    refreshPage: 'Refresh Page',
    logIssue: 'Log Issue',
  },
} as const;
